export interface StateI {
  id: string;
  stateCode: string;
  stateName: string;
}
